module.exports = window.wp.latexToMathml;